import React from 'react';
import CardCommon, { CardCommonType } from '../CardCommon';

export default function CommonLock(props: CardCommonType) {
  return (
    <CardCommon
      empty={true}
      emptyHeight={'calc(100vh - 140px)'}
      loadingHeight={'calc(100vh - 140px)'}
      emptyTitleText="The Game Group has configured permission control for this page. "
      emptyDescText={`If necessary, please contact {contact}.`}
      {...props}
    ></CardCommon>
  );
}
